import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c41f082"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-cont" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-headline" }, " Möchtest du deine Rufnummer mitnehmen? ", -1))
const _hoisted_3 = { class: "form-fields" }

import Product from '@/classes/Product';
import BaseGridCol from '@/components/BaseGridCol.vue';
import BaseGridRow from '@/components/BaseGridRow.vue';
import Checkbox from '@/components/Checkbox.vue';
import Headline from '@/components/Headline.vue';
import InputField from '@/components/InputField.vue';
import AppAddressFields from '@/components/inputs/AppAddressFields.vue';
import AppOrderActions from '@/components/order/order/AppOrderActions.vue';
import SelectField from '@/components/SelectField.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InternetConfigNumberTransfer',
  props: /*#__PURE__*/_mergeModels({
    product: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
    "errors": {},
    "errorsModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['previous', 'next'], ["update:modelValue", "update:errors"]),
  setup(__props: any, { emit: __emit }) {



const form = _useModel<Record<string, any>>(__props, "modelValue");
const errors = _useModel<Record<string, string | undefined>>(__props, 'errors');

const currentProviderOptions = [
  'Telekom Deutschland GmbH',
  'Vodafone GmbH',
  'Vodafone Kabel Deutschland GmbH',
  'O² / Telefónica Germany GmbH & Co.',
  '1&1 Telecom GmbH',
  '1&1 Versatel Deutschland GmbH',
  'Tele2 GmbH',
  'Congstar GmbH',
  'Sonstiger Anbieter',
];

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(BaseGridRow, null, {
        default: _withCtx(() => [
          _createVNode(BaseGridCol, null, {
            default: _withCtx(() => [
              _createVNode(BaseGridRow, { small: "" }, {
                default: _withCtx(() => [
                  _createVNode(BaseGridCol, null, {
                    default: _withCtx(() => [
                      _createVNode(Checkbox, {
                        modelValue: form.value.isNumberTransfer,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.isNumberTransfer) = $event)),
                        error: errors.value.isNumberTransfer,
                        "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((errors.value.isNumberTransfer) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ich möchte meine Rufnummer mitnehmen. ")
                        ]),
                        _: 1
                      }, 8, ["modelValue", "error"])
                    ]),
                    _: 1
                  }),
                  (form.value.isNumberTransfer)
                    ? (_openBlock(), _createBlock(BaseGridCol, {
                        key: 0,
                        s: { xs: 12, xxl: 6 }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SelectField, {
                            label: "Altanbieter*",
                            search: "",
                            options: currentProviderOptions,
                            modelValue: form.value.currentProvider,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.currentProvider) = $event)),
                            error: errors.value.currentProvider,
                            "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => ((errors.value.currentProvider) = $event))
                          }, null, 8, ["modelValue", "error"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (form.value.isNumberTransfer)
                    ? (_openBlock(), _createBlock(BaseGridCol, {
                        key: 1,
                        s: { xs: 12, xxl: 6 }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(InputField, {
                            label: "Rufnummer*",
                            modelValue: form.value.phoneNumber,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.phoneNumber) = $event)),
                            error: errors.value.phoneNumber,
                            "onUpdate:error": _cache[5] || (_cache[5] = ($event: any) => ((errors.value.phoneNumber) = $event))
                          }, null, 8, ["modelValue", "error"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (form.value.isNumberTransfer)
                    ? (_openBlock(), _createBlock(BaseGridCol, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(Checkbox, {
                            modelValue: form.value.allowCancellation,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.allowCancellation) = $event)),
                            error: errors.value.allowCancellation,
                            "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => ((errors.value.allowCancellation) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Ich ermächtige die Stadtwerke Ahrensburg GmbH, die erforderliche Kündigung bei meinem derzeitigen Telekommunikationsanbieter für mich vorzunehmen. ")
                            ]),
                            _: 1
                          }, 8, ["modelValue", "error"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (form.value.isNumberTransfer)
                    ? (_openBlock(), _createBlock(BaseGridCol, { key: 3 }, {
                        default: _withCtx(() => [
                          _createVNode(Checkbox, {
                            modelValue: form.value.notIsConnectionOwner,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.notIsConnectionOwner) = $event)),
                            error: errors.value.notIsConnectionOwner,
                            "onUpdate:error": _cache[9] || (_cache[9] = ($event: any) => ((errors.value.notIsConnectionOwner) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Ich bin nicht Anschlussinhaber:in. ")
                            ]),
                            _: 1
                          }, 8, ["modelValue", "error"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (form.value.isNumberTransfer && form.value.notIsConnectionOwner)
            ? (_openBlock(), _createBlock(BaseGridCol, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(BaseGridRow, { small: "" }, {
                    default: _withCtx(() => [
                      _createVNode(BaseGridCol, null, {
                        default: _withCtx(() => [
                          _createVNode(Headline, {
                            "tag-name": "div",
                            size: "h6",
                            "text-align": "start",
                            bold: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Anschlussinhaber:in ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(BaseGridCol, { s: { xs: 12, xxl: 6 } }, {
                        default: _withCtx(() => [
                          _createVNode(InputField, {
                            label: "Vorname*",
                            modelValue: form.value.connectionOwner.firstName,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.connectionOwner.firstName) = $event)),
                            error: errors.value['connectionOwner.firstName'],
                            "onUpdate:error": _cache[11] || (_cache[11] = ($event: any) => ((errors.value['connectionOwner.firstName']) = $event))
                          }, null, 8, ["modelValue", "error"])
                        ]),
                        _: 1
                      }),
                      _createVNode(BaseGridCol, { s: { xs: 12, xxl: 6 } }, {
                        default: _withCtx(() => [
                          _createVNode(InputField, {
                            label: "Nachname*",
                            modelValue: form.value.connectionOwner.lastName,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.connectionOwner.lastName) = $event)),
                            error: errors.value['connectionOwner.lastName'],
                            "onUpdate:error": _cache[13] || (_cache[13] = ($event: any) => ((errors.value['connectionOwner.lastName']) = $event))
                          }, null, 8, ["modelValue", "error"])
                        ]),
                        _: 1
                      }),
                      _createVNode(BaseGridCol, null, {
                        default: _withCtx(() => [
                          _createVNode(AppAddressFields, {
                            postcode: form.value.connectionOwner.postcode,
                            "onUpdate:postcode": _cache[14] || (_cache[14] = ($event: any) => ((form.value.connectionOwner.postcode) = $event)),
                            "error-postcode": errors.value['connectionOwner.postcode'],
                            "onUpdate:errorPostcode": _cache[15] || (_cache[15] = ($event: any) => ((errors.value['connectionOwner.postcode']) = $event)),
                            city: form.value.connectionOwner.city,
                            "onUpdate:city": _cache[16] || (_cache[16] = ($event: any) => ((form.value.connectionOwner.city) = $event)),
                            "error-city": errors.value['connectionOwner.city'],
                            "onUpdate:errorCity": _cache[17] || (_cache[17] = ($event: any) => ((errors.value['connectionOwner.city']) = $event)),
                            street: form.value.connectionOwner.street,
                            "onUpdate:street": _cache[18] || (_cache[18] = ($event: any) => ((form.value.connectionOwner.street) = $event)),
                            "error-street": errors.value['connectionOwner.street'],
                            "onUpdate:errorStreet": _cache[19] || (_cache[19] = ($event: any) => ((errors.value['connectionOwner.street']) = $event)),
                            "house-number": form.value.connectionOwner.houseNumber,
                            "onUpdate:houseNumber": _cache[20] || (_cache[20] = ($event: any) => ((form.value.connectionOwner.houseNumber) = $event)),
                            "error-house-number": errors.value['connectionOwner.houseNumber'],
                            "onUpdate:errorHouseNumber": _cache[21] || (_cache[21] = ($event: any) => ((errors.value['connectionOwner.houseNumber']) = $event)),
                            "house-number-addon": form.value.connectionOwner.houseNumberAddon,
                            "onUpdate:houseNumberAddon": _cache[22] || (_cache[22] = ($event: any) => ((form.value.connectionOwner.houseNumberAddon) = $event)),
                            "error-house-number-addon": errors.value['connectionOwner.houseNumberAddon'],
                            "onUpdate:errorHouseNumberAddon": _cache[23] || (_cache[23] = ($event: any) => ((errors.value['connectionOwner.houseNumberAddon']) = $event))
                          }, null, 8, ["postcode", "error-postcode", "city", "error-city", "street", "error-street", "house-number", "error-house-number", "house-number-addon", "error-house-number-addon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(AppOrderActions, {
        labels: {
            previous: 'Zurück',
            next: form.value.isNumberTransfer ? 'Weiter' : 'Ohne Rufnummermitnahme weiter',
          },
        onPrevious: _cache[24] || (_cache[24] = ($event: any) => (emit('previous'))),
        onNext: _cache[25] || (_cache[25] = ($event: any) => (emit('next'))),
        "color-next": _ctx.product.branch
      }, null, 8, ["labels", "color-next"])
    ])
  ]))
}
}

})